import React from "react";
import "./Content.scss";
import DetailsSection from "./DetailsSection";
import ParallaxPhoto from "./ParallaxPhoto";
import Schedule from "./Schedule";
import Transport from "./Transport";
import Counter from "./Counter";
import ConfirmationContainer from "./ConfirmationContainer";
import logoImage from "./images/logo-n-a.webp";
function Content({ t }) {
  return (
    <div className="relative content-custom-margin">
      <div className="hidden-mxl"><Transport t={t} /></div>
      <ParallaxPhoto photoClass="parallax-engaged">
        <h1 id="schedule" className="text-white text-center letter-spacing-4px">
          {t.program}
        </h1>
        <div className="flex flex-align-center flex-justify-center gap-1 hearth-separator m-top-0"><div className="heart-separator-line bg-third"></div><i className="fa-solid fa-heart text-third text-xs"></i><div className="heart-separator-line bg-third"></div></div>
      </ParallaxPhoto>
      <Schedule t={t} />
      <DetailsSection t={t} />
      <Counter t={t} />
      <ConfirmationContainer t={t} />
      <div className="p-top-12 p-top-4-xs bg-base p-bottom-6 text-center">
        <h5>{t.withLove}</h5>
        <h3 className="letter-spacing-2px">{t.coupleNames}</h3>
        <img src={logoImage} className="logo-image m-auto" width="100%" height="auto" />
        <div className="container m-auto flex p-top-12 p-top-4-xs">
          <hr className="flex flex-justify-center col-12-xs col-12-sm col-8 hr-style m-top-2 m-bottom-2 m-left-auto m-right-auto" />
        </div>
        <div>{t.copyright}</div>
        <div>
          {t.author}
          <i className="m-left-1 fa-solid fa-hand-holding-heart"></i>
        </div>
      </div>
    </div>
  );
}

export default Content;
